export default __webpack_public_path__ + "static/media/Group 1.0b853047.svg";